import React from "react";
import {
  getPlatformUrl,
  getDevdocsUrl,
} from "../../shared/config/urls";

const CustomFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="">
      <div className="grid grid-cols-1 md:grid-cols-4 lg:gap-6 gap-4">
        {/* YouVersion Platform */}
        <div className="md:col-span-1">
          <h3 className="font-semibold text-base sm:text-lg mb-2 sm:mb-3">
            YouVersion Platform
          </h3>
          <p className="text-muted-foreground text-xs sm:text-sm leading-relaxed">
            Build applications and integrate with the world's most popular Bible
            platform.
          </p>
        </div>

        {/* Products */}
        <div>
          <h4 className="font-medium text-base sm:text-lg mb-2 sm:mb-3">
            Platform Products
          </h4>
          <ul className="space-y-2 text-xs sm:text-sm">
            <li>
              <a
                href={getPlatformUrl()}
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                Platform Portal
              </a>
            </li>
            <li>
              <a
                href={getDevdocsUrl()}
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                Developer Documentation
              </a>
            </li>
            {/* Bible Directory link hidden */}
            <li className="hidden">
              <a
                href="/platform/apps"
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                App Management
              </a>
            </li>
          </ul>
        </div>

        {/* Resources */}
        <div>
          <h4 className="font-medium text-base sm:text-lg mb-2 sm:mb-3">
            Resources
          </h4>
          <ul className="space-y-2 text-xs sm:text-sm">
            <li>
              <a
                href={`${getPlatformUrl()}/support`}
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                Support
              </a>
            </li>
            <li>
              <a
                href={`mailto:press@youversion.com`}
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                Press inquiries
              </a>
            </li>
          </ul>
        </div>

        {/* Legal */}
        <div>
          <h4 className="font-medium text-base sm:text-lg mb-2 sm:mb-3">
            Legal
          </h4>
          <ul className="space-y-2 text-xs sm:text-sm">
            <li>
              <a
                href="https://www.bible.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                Privacy Policy
              </a>
            </li>
            <li>
              <a
                href={`${getPlatformUrl()}/?tos=1`}
                className="text-muted-foreground hover:text-foreground transition-colors"
              >
                Terms of Use
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Dev Stuff section removed */}

      {/* Copyright */}
      <div className="mt-8 pt-6 border-t border-border">
        <p className="text-xs sm:text-sm text-muted-foreground">
          © {currentYear} YouVersion. All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default CustomFooter;
